(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offgrid-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    root.querySelectorAll('.og-buy').forEach(form => {
      form.addEventListener('change', event => {
        const radio = event.target.closest('input[name="id"]');
        if (!radio) return;
        const card = form.closest('.og-product');
        const image = card.querySelector('.og-product-media img');
        if (radio.dataset.image) image.src = radio.dataset.image;
        if (radio.dataset.alt) image.alt = radio.dataset.alt;
        card.querySelector('[data-product-price]').textContent = radio.dataset.price;
        const note = form.querySelector('.og-selection-note');
        note.textContent = radio.dataset.detail;
        form.querySelector('.og-buy-status').textContent = '';
        form.querySelector('[type="submit"]').disabled = radio.dataset.available === 'false';
      });
      form.addEventListener('submit', event => {
        if (!form.reportValidity()) { event.preventDefault(); return; }
        const selected = form.querySelector('input[name="id"]:checked');
        if (!selected || selected.dataset.available === 'false') { event.preventDefault(); return; }
        if (form.dataset.preview === 'true') {
          event.preventDefault();
          form.querySelector('.og-buy-status').textContent = selected.dataset.previewMessage;
        }
      });
    });
    root.querySelectorAll('video').forEach(video => {
      video.addEventListener('play', () => root.querySelectorAll('video').forEach(other => { if (other !== video) other.pause(); }));
    });
    root.querySelectorAll('[data-play-target]').forEach(button => button.addEventListener('click', () => {
      const video = root.querySelector('#' + button.dataset.playTarget);
      if (!video) return;
      video.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'center'});
      video.focus({preventScroll:true});
      video.play().catch(() => {});
    }));
    const dialog = root.querySelector('.og-dialog');
    let imageTrigger;
    root.querySelectorAll('[data-open-image]').forEach(button => button.addEventListener('click', () => {
      imageTrigger = button;
      const image = dialog.querySelector('img');
      image.src = button.dataset.openImage;
      image.alt = button.querySelector('img').alt;
      dialog.showModal();
    }));
    dialog.querySelector('.og-dialog-close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => imageTrigger?.focus());
    root.querySelectorAll('.og-mobile-nav a').forEach(link => link.addEventListener('click', () => { link.closest('details').open = false; }));
  };
  document.querySelectorAll('.og-home').forEach(init);
  document.addEventListener('shopify:section:load', event => init(event.target.querySelector('.og-home')));
})();

// Presentation-only enhancement of the existing Elfsight widget. Review content stays with Elfsight.
(() => {
  const init = root => {
    const mount = root?.querySelector('#og-review-widget');
    if (!mount || mount.dataset.controlsInitialized) return;
    mount.dataset.controlsInitialized = 'true';
    const controls = root.querySelector('.og-review-controls');
    let track;
    const update = () => {
      if (!track) return;
      const end = track.scrollWidth - track.clientWidth;
      controls.querySelector('[data-review-direction="-1"]').disabled = track.scrollLeft < 3;
      controls.querySelector('[data-review-direction="1"]').disabled = track.scrollLeft >= end - 3;
    };
    const connect = () => {
      const candidate = mount.querySelector('.es-masonry-layout');
      if (!candidate || !candidate.querySelector('.es-review-container')) return;
      if (candidate !== track) {
        track?.removeEventListener('scroll', update);
        track = candidate;
        track.id = 'og-reviews-scroll';
        track.tabIndex = 0;
        track.setAttribute('aria-label', mount.dataset.scrollLabel);
        track.setAttribute('role', 'region');
        track.addEventListener('scroll', update, { passive: true });
        controls.querySelectorAll('button').forEach(b => b.setAttribute('aria-controls', track.id));
        new ResizeObserver(update).observe(track);
      }
      controls.hidden = false;
      requestAnimationFrame(update);
    };
    controls.querySelectorAll('button').forEach(button => button.addEventListener('click', () => {
      if (!track) return;
      track.scrollBy({left: Number(button.dataset.reviewDirection) * (track.clientWidth + 20), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }));
    new MutationObserver(connect).observe(mount, {childList: true, subtree: true});
    connect();
  };
  document.querySelectorAll('.og-home').forEach(init);
  document.addEventListener('shopify:section:load', e => init(e.target.querySelector('.og-home')));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offgrid-usecase"]) return;
  try {
    
(()=>{const init=root=>{if(!root||root.dataset.copyInitialized)return;root.dataset.copyInitialized='true';root.querySelectorAll('[data-copy-prompt]').forEach(button=>button.addEventListener('click',async()=>{const status=root.querySelector('.og-uc-copy-status');try{await navigator.clipboard.writeText(button.closest('article').querySelector('p').textContent);status.textContent=status.dataset.copySuccess;}catch{status.textContent=status.dataset.copyFailure;}}));};document.querySelectorAll('.og-usecase').forEach(init);document.addEventListener('shopify:section:load',e=>init(e.target.querySelector('.og-usecase')));})();

  } catch(e) { console.error(e); }
})();
})();
